import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractDialogResultData,
  AbstractFormDialog,
  AbstractFormDialogData,
  DIALOG_RETURN_TYPES,
} from '@next/core-lib/dialog';

import { ProductionPurposeCategory, UpsertProductionPurposeCategoryRequest } from '../../models';

export interface ProductionPurposeCategoryDialogInputData extends AbstractFormDialogData {
  productionPurposeCategory: ProductionPurposeCategory;
}
@Component({
  selector: 'app-create-production-purpose-category-dialog',
  templateUrl: './create-production-purpose-category-dialog.component.html',
  styleUrl: './create-production-purpose-category-dialog.component.scss',
  standalone: false,
})
export class CreateProductionPurposeCategoryDialogComponent
  extends AbstractFormDialog<UpsertProductionPurposeCategoryRequest>
  implements OnInit {
  data = inject<ProductionPurposeCategoryDialogInputData>(MAT_DIALOG_DATA);
  private readonly formBuilder = inject(FormBuilder);
  protected readonly mdDialogRef =
    inject<
      MatDialogRef<
        CreateProductionPurposeCategoryDialogComponent,
        AbstractDialogResultData<UpsertProductionPurposeCategoryRequest>
      >
    >(MatDialogRef);

  formGroup: FormGroup = this.formBuilder.group({
    name: [
      null as string | null,
      [Validators.required, Validators.maxLength(2), Validators.pattern('^[a-zA-Z]*$')],
    ],
    description: [null as string | null, [Validators.required, Validators.maxLength(50)]],
    n1: [
      null as number | null,
      [Validators.required, Validators.min(1), Validators.max(999), Validators.pattern('^[0-9]+$')],
    ],
    n2: [
      null as number | null,
      [Validators.required, Validators.min(1), Validators.max(999), Validators.pattern('^[0-9]+$')],
    ],
    n3: [
      null as number | null,
      [Validators.required, Validators.min(1), Validators.max(999), Validators.pattern('^[0-9]+$')],
    ],
    baseYieldPotential: [
      null as number | null,
      [
        Validators.required,
        Validators.min(0),
        Validators.max(99999),
        Validators.pattern('^[0-9]+$'),
      ],
    ],
    nCorrection: [
      null as number | null,
      [
        Validators.required,
        Validators.min(0),
        Validators.max(99999),
        Validators.pattern('^[0-9]+$'),
      ],
    ],
    nO3NormTreshold: [
      null as number | null,
      [
        Validators.required,
        Validators.min(0),
        Validators.max(99999),
        Validators.pattern('^[0-9]+$'),
      ],
    ],
    trendlineTuningA: [
      null as number | null,
      [
        Validators.required,
        Validators.min(-9999.999999),
        Validators.max(9999.999999),
        Validators.pattern(/^-?(\d+(\.\d*)?|\.\d+)$/),
      ],
    ],
    trendlineTuningB: [
      null as number | null,
      [
        Validators.required,
        Validators.min(-9999.999999),
        Validators.max(9999.999999),
        Validators.pattern(/^-?(\d+(\.\d*)?|\.\d+)$/),
      ],
    ],
    trendlineTuningC: [
      null as number | null,
      [
        Validators.required,
        Validators.min(-9999.999999),
        Validators.max(9999.999999),
        Validators.pattern(/^-?(\d+(\.\d*)?|\.\d+)$/),
      ],
    ],
    trendlineTuningD: [
      null as number | null,
      [
        Validators.required,
        Validators.min(-9999.999999),
        Validators.max(9999.999999),
        Validators.pattern(/^-?(\d+(\.\d*)?|\.\d+)$/),
      ],
    ],
  });
  displayNameField = true;
  ngOnInit(): void {
    if (this.data.productionPurposeCategory) {
      this.displayNameField = false;
      this.formGroup.patchValue(this.data.productionPurposeCategory);
    }
  }
  confirm(): void {
    if (this.formGroup.valid) {
      this.mdDialogRef.close({ status: DIALOG_RETURN_TYPES.confirm, result: this.formGroup.value });
    }
  }
}
